<!--
 * @Description:  回顾往期 模块
 * @Author: Fore-Zhang
 * @Date: 2021-01-12 01:14:40
 * @LastEditTime: 2021-01-15 13:31:31
-->

<template>
  <div id="previewPage" :style="previewPageStyle">
    <div id="previewContainer">
      <!-- 第一期表头  开始 -->
      <div
        class="titleContainer"
        @touchstart="ontouchstart($event)"
        @touchmove="ontouchmove($event)"
        @click="titlebuttonOne()"
      >
        <div class="previewIssueTitle">第一期 · 后直播时代</div>
        <div id="close_bt" @click="openclose()">
          <img src="../assets/preview_close_bt.png" />
        </div>
      </div>
      <!-- 第二期表头  开始 -->
      <div
        class="titleContainer"
        @touchstart="ontouchstart($event)"
        @touchmove="ontouchmove($event)"
        @click="titlebuttonTwo()"
        style="border-top: solid .002rem #f1f1f1"
      >
        <div class="previewIssueTitle">第二期 · 增长创意</div>
      </div>
      <!-- 推荐 人物说 开始  -->
      <div class="ClassLabelArea" v-show="titlebuttonTrue">
        <div class="LabelContainer">
          <div class="LabelTextContainer LabelTextContainerLeft">
            <div
              class="ClassLabel"
              :class="{ selectLabel: select == 2 }"
              @click="select = 2"
            >
              推荐
            </div>
            <!--            <div class="ClassLabel" :class="{selectLabel:select==2}" @click="select=2">后直播时代</div>-->
          </div>
          <div class="LabelTextContainer LabelTextContainerRight">
            <div
              class="ClassLabel"
              :class="{ selectLabel: select == 3 }"
              @click="select = 3"
            >
              人物说
            </div>
          </div>
        </div>
      </div>
      <!-- 推荐 人物说 开始  -->
      <div class="ClassLabelArea" v-show="titlebuttonFalse">
        <div class="LabelContainer">
          <div class="LabelTextContainer LabelTextContainerLeft">
            <div
              class="ClassLabel"
              :class="{ selectLabel: select == 1 }"
              @click="select = 1"
            >
              推荐
            </div>
            <!--            <div class="ClassLabel" :class="{selectLabel:select==2}" @click="select=2">后直播时代</div>-->
          </div>
          <div class="LabelTextContainer LabelTextContainerRight">
            <div
              class="ClassLabel"
              :class="{ selectLabel: select == 4 }"
              @click="select = 4"
            >
              人物说
            </div>
          </div>
        </div>
      </div>
      <!-- 文章列表 开始  -->
      <div id="ListContainer" :style="ListContainerStyle">
        <component
          style="background: #f1f1f1"
          :is="'class' + select"
        ></component>
      </div>

    </div>
  </div>
</template>

<script>
import class1 from './previewClass1';
import class4 from './previewClass4';
import class2 from "./previewClass2";
import class3 from "./previewClass3";
import pageStackStore from "../store/pageStackStore";
import store from "../store/";


export default {
  name: "preview",
  data: function () {
    return {
      select: 2,
      touch: { x: 0, y: 0 },
      titlebuttonTrue: true,
      titlebuttonFalse: false,
    };
  },
  components: {
    class1,
    class2,
    class3,
    class4,
  },
  methods: {
    openclose() {
      pageStackStore.commit("OpenClose");
    },
    titlebuttonOne() {
      if(this.titlebuttonFalse) {
        this.select=2;
        this.titlebuttonTrue = true;
        this.titlebuttonFalse = false;
      }
    },
    titlebuttonTwo() {
      if(this.titlebuttonTrue) {
        this.select=1;
        this.titlebuttonTrue = false;
        this.titlebuttonFalse = true;
      }
    },
    ontouchstart(e) {
      this.touch.y = e.changedTouches[0].clientY;
    },
    ontouchmove(e) {
      if ((e.changedTouches[0].clientY - this.touch.y) * this.p > 100) {
        if (pageStackStore.state.preveiwOpen) {
          pageStackStore.commit("OpenClose");
        }
      }
    },
  },
  computed: {
    previewPageStyle() {
      return {
        height: store.state.WindowSize.WindowHeightRem - 0.9 + "rem",
      };
    },
    ListContainerStyle() {
      return {
        height:
          store.state.WindowSize.WindowHeightRem - 0.9 - 1.31 - 1.11 + "rem",
      };
    },
  },
};
</script>
<style lang="less" scoped>
@fullWidth: 11.25rem;
.fullWidhth {
  width: @fullWidth;
}

#previewPage {
  //.fullWidhth();
  width: 100%;

  position: absolute;
  transition-duration: 0.5s;
  top: 0.9rem;

  #previewContainer {
    //.fullWidhth();
    width: 100%;

    height: 100%;
    border-radius: 0.5rem 0.5rem 0rem 0rem;
    background: #ffffff;

    .titleContainer {
      .fullWidhth();

      .previewIssueTitle {
        width: 9.45rem;
        margin-left: 0.9rem;
        line-height: 1.31rem;
        font-size: 0.55rem;
        text-align: center;
        color: grey;
      }
      #close_bt {
        width: 0.33rem;
        margin-top: 0.51rem;

        img {
          width: 100%;
        }
      }
    }

    .ClassLabelArea {
      .fullWidhth();

      height: 1.11rem;
      background: #1a8bff;

      .LabelContainer {
        width: 9.45rem;
        margin-left: 0.9rem;
        height: 1.11rem;
      }
      .LabelTextContainer {
        width: 50%;
        margin-top: 0.17rem;
        height: 0.77rem;
        display: flex;
        justify-content: center;

        .ClassLabel {
          font-size: 0.42rem;
          margin-top: 0.1rem;
          color: #ffffff;
          padding-bottom: 0.4rem;
          padding-left: 0.1rem;
          padding-right: 0.1rem;
        }
        .selectLabel {
          border-bottom: 0.07rem solid #ffffff;
        }
      }

      .LabelTextContainerLeft {
        border-right: 0.01rem solid #ffffff;
      }
      .LabelTextContainerRight {
        border-left: 0.01rem solid #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preview.vue